import React, { useState, useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { Button } from "@mui/material";
import "./ImageGallery.css"
import { farmers } from "../../config/images";

const ImageGallery = ({ images, isOpen, onClose, imageIndex }) => {

    const [currentIndex, setCurrentIndex] = useState(imageIndex);

    useEffect(() => {
        setCurrentIndex(imageIndex);
    }, [imageIndex]);


    const handlePrevious = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));

    }

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }


    const handleImageClick = (index) => {
        setCurrentIndex(index);
    };

    return (

        <div className="image-gallery-overlay">
            <div className="image-galley-popup">
                <img src={images[currentIndex]} alt="img-main" className="image-gallery-img" />
                <img src={farmers.cancelIcon} alt="" className="cancel-icon" onClick={() => onClose()} />
                <div className="image-gallery-arrows">
                    <img src={farmers.leftArrow} alt="left-arrow" className="left-arrow" onClick={handlePrevious} />
                    <img src={farmers.rightArrow} alt="right-arrow" className="right-arrow" onClick={handleNext} />
                </div>


                {/* Thumbnail Gallery */}
                <div className="thumbnail-gallery">
                    {images.map((img, index) => (
                        <img
                            key={index}
                            src={img}
                            alt={`thumbnail-${index}`}
                            className={`thumbnail ${index === currentIndex ? "active" : ""}`}
                            onClick={() => handleImageClick(index)}
                        />
                    ))}
                </div>
            </div>
        </div>

    )
}

export default ImageGallery;